import React from 'react'
import CreditImg from '../../Images/CreditImg/LandLoan.jpg'
import SideNavCredit from '../Navigation/SideNavCredit'
import Aos from 'aos'

const LandHomeLoan = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNavCredit />
                    </div>
                    <div className='d-body-main'>
                        <div className='saving-body-top' data-aos='fade-right'>
                            <h2>घर जग्गा खरिद ऋण</h2>
                        </div>
                        <div className='saving-body' data-aos='fade-right'>
                            <div className='saving-main'>
                                <h3>विवरण :</h3>
                                <p>
                                    <ul>
                                        <li>संकेत नंः ११०.५</li>
                                        <li>ऋणको उद्देश्यः सदस्यहरूलाई घर तथा जग्गा खरिद गर्न सहयोग गर्ने ।</li>
                                        <li>ऋणको सिमाः अधिकतम रु.३० लाखसम्म ।</li>
                                        <li>ब्याजदरः संस्थाले तोके बमोजिम ।</li>
                                        <li>किस्ताः मासिक ब्याज र मासिक / त्रैमासिक किस्ता ।</li>
                                        <li>समयावधिः १२ वर्ष</li>
                                        <li>धितो व्यवस्थाः जग्गा धितो </li>
                                    </ul>
                                </p>

                            </div>
                            <div className='savingimg'>
                                <img src={CreditImg} alt='Credit-1' />
                            </div>
                        </div>
                        <div className='saving-footer' data-aos='fade-right'>
                            <h3>विशेषताहरू :</h3>
                            <p>
                                <ul>
                                    <li>सदस्यले घर निर्माण तथा मर्मत गर्न ऋण लगानी गर्न सकिने ।</li>
                                    <li>मासिक ब्याज त्रैमासिक किस्ता बुझाउनु पर्ने ।</li>
                                    <li>दैनिक तथा मासिक ऋणको किस्ता भुक्तानी गरेमा ब्याजदरमा १% कम लाग्ने ।</li>
                                    <li>व्यवस्थापन शुल्क कुल ऋणको ०.८% लाग्ने ।</li>
                                    <li>समयमा ऋण नतिरेमा भाखा नाघेको ऋणको किस्तामा ५% हर्जना लाग्ने ।</li>
                                    <li>ब्याज भाखा नाघेमा पहिलो महिना पाकेको ब्याजमा १८, दोस्रो महिना २०, तेस्रो महिना २२ र चौथो महिना २४ प्रतिशतले दैनिक गणनाको आधारमा हर्जना लाग्ने ।</li>
                                    <li>अग्रिम तिर्न सकिने ।</li>
                                    <li>ऋण तथा ब्याज बुझाउनका लागि कर्मचारी घरमा नै पठाउन सकिने । </li>
                                    <li>सम्मान तथा पुरस्कार प्राप्त गर्न सकिने ।</li>
                                    <li>भाखा ननघाई बुझाएको ब्याजलाई संरक्षित पूँजी फिर्ता कोषमा गणना गरीने ।</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default LandHomeLoan